import React from 'react';
import verifySealImg from '../../assets/images/verify-seal.png';

const isVerified = (value) => Number(value) === 1 || value === true || value === '1';

/** High-quality verified seal (image + crisp SVG fallback). */
const VerifySeal = ({ ok }) => (
  <span className={`hs-seal ${ok ? 'hs-seal--ok' : 'hs-seal--off'}`} aria-hidden>
    <img
      src={verifySealImg}
      alt=""
      className="hs-seal__img"
      width={22}
      height={22}
      draggable={false}
    />
  </span>
);

const Item = ({ label, ok }) => (
  <span
    className={`hs-vitem ${ok ? 'is-verified' : 'is-unverified'}`}
    title={ok ? `${label} verified` : `${label} not verified`}
  >
    <span className="hs-vitem__label">{label}</span>
    <VerifySeal ok={ok} />
  </span>
);

/**
 * Simple Mobile / Email text + seal badge.
 * Green seal when verified; faded gray when not.
 */
const VerificationBadges = ({ verifyMobile, verifyEmail, compact = false, className = '' }) => {
  const mobileOk = isVerified(verifyMobile);
  const emailOk = isVerified(verifyEmail);

  return (
    <div className={`hs-vsimple ${compact ? 'is-compact' : ''} ${className}`.trim()}>
      <Item label="Mobile" ok={mobileOk} />
      <Item label="Email" ok={emailOk} />
      <style>{`
.hs-vsimple {
  display: flex !important;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 16px;
  background: transparent !important;
  padding: 0 !important;
  box-shadow: none !important;
  border: none !important;
  margin-left: auto !important;
  margin-right: auto !important;
  text-align: center;
}
.hs-vitem {
  display: inline-flex !important;
  align-items: center;
  gap: 7px;
  line-height: 1;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 0 !important;
  color: inherit !important;
}
.hs-vitem__label {
  font-size: 15px !important;
  font-weight: 600 !important;
  color: #1f2937 !important;
  background: none !important;
  text-transform: none !important;
}
.hs-seal {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
}
.hs-seal__img {
  width: 22px;
  height: 22px;
  object-fit: contain;
  display: block;
  user-select: none;
  pointer-events: none;
}
.hs-seal--ok .hs-seal__img {
  filter: none;
  opacity: 1;
}
.hs-seal--off .hs-seal__img {
  filter: grayscale(1) brightness(1.35) contrast(0.85);
  opacity: 0.45;
}
.hs-vitem.is-unverified .hs-vitem__label {
  color: #9ca3af !important;
}
.hs-vsimple.is-compact {
  gap: 12px;
}
.hs-vsimple.is-compact .hs-vitem__label {
  font-size: 12px !important;
}
.hs-vsimple.is-compact .hs-seal,
.hs-vsimple.is-compact .hs-seal__img {
  width: 16px;
  height: 16px;
}
.member-card .hs-vsimple {
  margin-top: 6px;
  justify-content: center !important;
  width: 100% !important;
}
.filter-card-gallery .member-info .hs-vsimple,
.member-info .hs-vsimple {
  justify-content: center !important;
  width: 100% !important;
}
.view-profile-page .pro-info-status .hs-vsimple {
  justify-content: center !important;
  width: auto !important;
  flex: 0 0 auto !important;
  display: inline-flex !important;
}
.view-profile-page .pro-info-status .hs-vsimple,
.view-profile-page .pro-info-status .hs-vitem,
.view-profile-page .pro-info-status .hs-vitem__label,
.view-profile-page .pro-info-status .hs-seal {
  background: transparent !important;
  color: inherit !important;
  float: none !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
}
`}</style>
    </div>
  );
};

export default VerificationBadges;
export { isVerified };
